/* Nancy's Tanks — cart drawer extras: reservation timer + bundle upsell popup on Check out.
   The drawer HTML is re-rendered by Dawn after every cart change, so everything here works by
   looking elements up fresh (timer) or by delegated listeners (upsell). */
(function () {
  'use strict';
  if (window.__ntCart) return;
  window.__ntCart = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function store(kind) {
    try { var s = window[kind]; var k = '__nt_t'; s.setItem(k, '1'); s.removeItem(k); return s; } catch (e) { return null; }
  }
  var local = store('localStorage');
  var session = store('sessionStorage');
  var mem = {};
  function get(s, k) { try { return s ? s.getItem(k) : (k in mem ? mem[k] : null); } catch (e) { return mem[k] || null; } }
  function set(s, k, v) { try { if (s) s.setItem(k, v); else mem[k] = v; } catch (e) { mem[k] = v; } }

  /* ---------- Reservation timer (10 minutes, renews when it runs out) ---------- */
  var TIMER_KEY = 'nt_cart_reserved_until';
  var TIMER_MS = 10 * 60 * 1000;

  function timerEnd() {
    var end = parseInt(get(local, TIMER_KEY), 10);
    if (!end || isNaN(end) || end <= Date.now()) {
      end = Date.now() + TIMER_MS;
      set(local, TIMER_KEY, String(end));
    }
    return end;
  }

  function tick() {
    var outs = document.querySelectorAll('[data-nt-cart-timer-out]');
    if (!outs.length) return;
    var left = Math.max(0, timerEnd() - Date.now());
    var m = Math.floor(left / 60000);
    var s = Math.floor((left % 60000) / 1000);
    var text = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    for (var i = 0; i < outs.length; i++) outs[i].textContent = text;
    var wraps = document.querySelectorAll('[data-nt-cart-timer]');
    for (var j = 0; j < wraps.length; j++) wraps[j].classList.toggle('is-low', left < 120000);
  }
  setInterval(tick, 1000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick);
  else tick();

  /* ---------- Bundle upsell popup on Check out ---------- */
  var goingToCheckout = false;
  var openModal = null;

  function goCheckout() {
    goingToCheckout = true;
    window.location.href = ROOT + 'checkout';
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('nt-up-open');
    document.removeEventListener('keydown', modal.__ntKey);
    setTimeout(function () { if (modal.parentNode) modal.parentNode.removeChild(modal); }, 260);
    openModal = null;
    var back = document.getElementById('CartDrawer-Checkout');
    if (back) try { back.focus(); } catch (e) {}
  }

  function showUpsell(tpl, seenKey) {
    var data;
    var frag = tpl.content.cloneNode(true);
    var modal = frag.querySelector('.nt-up');
    if (!modal) return false;
    try { data = JSON.parse(frag.querySelector('[data-nt-up-variants]').textContent); } catch (e) { return false; }

    var variants = data.variants || [];
    function find(color, size) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].o || [];
        if (o[data.colorIdx] === color && o[data.sizeIdx] === size) return variants[i];
      }
      return null;
    }
    function imageFor(color) {
      for (var i = 0; i < variants.length; i++) {
        if ((variants[i].o || [])[data.colorIdx] === color && variants[i].i) return variants[i].i;
      }
      return '';
    }

    var rows = modal.querySelectorAll('[data-nt-up-row]');
    Array.prototype.forEach.call(rows, function (row) {
      var c = row.querySelector('[data-nt-up-color]');
      var s = row.querySelector('[data-nt-up-size]');
      var img = row.querySelector('[data-nt-up-img]');
      if (!c || !s) return;
      function sync() {
        Array.prototype.forEach.call(s.options, function (opt) {
          var v = find(c.value, opt.value);
          var ok = !!(v && v.a);
          opt.disabled = !ok;
          opt.textContent = opt.value + (ok ? '' : ' (sold out)');
        });
        if (s.selectedOptions[0] && s.selectedOptions[0].disabled) {
          var firstOk = Array.prototype.filter.call(s.options, function (o) { return !o.disabled; })[0];
          if (firstOk) s.value = firstOk.value;
        }
        var src = imageFor(c.value);
        if (img && src) img.src = src;
      }
      c.addEventListener('change', sync);
      s.addEventListener('change', sync);
      sync();
    });

    var msg = modal.querySelector('[data-nt-up-msg]');
    var yes = modal.querySelector('[data-nt-up-yes]');
    var no = modal.querySelector('[data-nt-up-no]');

    function markSeen() { set(session, seenKey, '1'); }

    Array.prototype.forEach.call(modal.querySelectorAll('[data-nt-up-close]'), function (el) {
      el.addEventListener('click', function () { markSeen(); closeModal(modal); });
    });
    no.addEventListener('click', function () {
      markSeen();
      no.textContent = 'Taking you to checkout…';
      goCheckout();
    });

    yes.addEventListener('click', function () {
      var counts = {};
      var problem = '';
      if (rows.length) {
        Array.prototype.forEach.call(rows, function (row, idx) {
          var c = row.querySelector('[data-nt-up-color]');
          var s = row.querySelector('[data-nt-up-size]');
          var v = c && s ? find(c.value, s.value) : { id: data.fallbackId, a: true };
          if (!v || !v.a) { problem = 'That color and size is sold out. Please pick another one.'; return; }
          counts[v.id] = (counts[v.id] || 0) + 1;
        });
      }
      if (problem) { msg.textContent = problem; return; }
      var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      if (!items.length) { goCheckout(); return; }

      yes.setAttribute('aria-busy', 'true');
      msg.textContent = '';
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) {
            yes.removeAttribute('aria-busy');
            msg.textContent = res.description || res.message || 'Could not add those tanks. Please try again.';
            return;
          }
          markSeen();
          goCheckout();
        })
        .catch(function () {
          yes.removeAttribute('aria-busy');
          msg.textContent = 'Could not add those tanks. Please check your connection and try again.';
        });
    });

    modal.__ntKey = function (e) {
      if (e.key === 'Escape') { markSeen(); closeModal(modal); return; }
      if (e.key !== 'Tab') return;
      var f = modal.querySelectorAll('button:not([disabled]), select, a[href]');
      if (!f.length) return;
      var firstEl = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
    };
    document.addEventListener('keydown', modal.__ntKey);

    document.body.appendChild(modal);
    document.documentElement.classList.add('nt-up-open');
    openModal = modal;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { modal.classList.add('is-open'); try { yes.focus({ preventScroll: true }); } catch (e) {} });
    });
    return true;
  }

  document.addEventListener('click', function (e) {
    if (goingToCheckout || openModal) return;
    var btn = e.target && e.target.closest ? e.target.closest('#CartDrawer-Checkout') : null;
    if (!btn) return;
    var tpl = document.getElementById('nt-upsell-tpl');
    if (!tpl || !('content' in tpl)) return;
    var seenKey = 'nt_upsell_seen_' + (tpl.getAttribute('data-nt-upsell-key') || '');
    if (get(session, seenKey)) return;
    if (showUpsell(tpl, seenKey)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();
